import { trackPublicEvent } from "@/features/analytics/api";
import type {
  EventPrefix,
  GoogleTagManagerEventDetails,
} from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";
import type { PaymentMethodType } from "@/shared/domains/payments/models";

interface TrackPaymentMethodSelectedParams {
  paymentMethod: PaymentMethodType;
  userId?: string;
  eventPrefix?: EventPrefix;
}

export const trackPaymentMethodSelected = ({
  paymentMethod,
  userId,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackPaymentMethodSelectedParams) => {
  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.PAYMENT_METHOD_SELECTED}`,
    ecommerce: {
      currency: "",
      value: 0,
      items: [],
      paymentMethod,
    },
  });

  trackPublicEvent({
    event: `${eventPrefix}${CUSTOMER_IO_EVENT.PAYMENT_METHOD_SELECTED}`,
    properties: {
      paymentMethod,
      source: window.location.href,
    },
    userId,
  });
};
